export const IMAGES = {
  hero: "https://customer-assets-7cd3h4nn.emergentagent.net/job_6f73db8c-5b62-4a11-96dc-09ef7a73f087/artifacts/acz0i8d9_IMG_0194.jpeg",
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_6f73db8c-5b62-4a11-96dc-09ef7a73f087/artifacts/nmjzmnsq_IMG_0195.jpeg",
  bresaola: "https://customer-assets-7cd3h4nn.emergentagent.net/job_6f73db8c-5b62-4a11-96dc-09ef7a73f087/artifacts/euz3q1o1_IMG_0197.jpeg",
  chef: "https://customer-assets-7cd3h4nn.emergentagent.net/job_6f73db8c-5b62-4a11-96dc-09ef7a73f087/artifacts/9pvw4bkn_IMG_0196.jpeg",
  walnut: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/xvgsfqqq_IMG_0204.jpeg",
  pistachio: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/njngbz7t_IMG_0205.webp",
  wine: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/5qgmtc73_IMG_0206.jpeg",
  spezzata: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/r8vtmzw0_IMG_5207.webp",
  spezzataSalata: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/rppi046q_988838e8-f6be-42ba-8340-78fa2f14af40.webp",
  spezzataDolce: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/ib7btjs7_IMG_0646.jpeg",
  rinaldo: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/r9oqm16d_cc11c405-770e-4c61-acab-182ea3c82bdd.jpeg",
  nordica: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/qiw7agq9_IMG_0194.jpeg",
  trunzo: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/oyduwpth_IMG_5211.webp",
  angelica: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/vlyvpcif_7e202e04-be27-4fce-b9c8-cae79960a189.jpeg",
  delicata: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/x9qn162j_a4615d87-0577-47bd-84ad-2ebe83d69332.webp",
  elica: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/y9ou3t47_19defe77-15d9-4228-8fab-049b5a2faf61.webp",
  etna: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/6rmpa263_b1aa0295-c994-40a2-b529-6b51b92c6c4b.jpeg",
  vintage: "/assets/pizzaiolo-anni80.jpg",
  chefPistachio: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/yi1fojh8_5c1cc8d6-add7-41e0-a7b8-f11710475403.webp",
  dough: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/peh8jig9_914f991b-657b-4cf5-a67b-262f45d32f98.webp",
  boxMan: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/kb8i8821_d1d110fd-b3f1-496f-b0f2-f7d9691b7406.webp",
  oven: "https://customer-assets-rejwkqb3.emergentagent.net/job_taste-bella/artifacts/zvysonmz_7a2e24c0-71ee-44aa-8c83-e13efd79765b.webp",
  datterina: "/assets/datterina.jpg",
};

export const CONTACTS = {
  phone: "+39 340 755 3862",
  phoneHref: "tel:+393407553862",
  whatsapp: "https://wa.me/393407553862",
  address: "Via Vittorio Emanuele II, 191 — Acireale (CT)",
  mapsEmbed: "https://www.google.com/maps?q=Via+Vittorio+Emanuele+II+191,+Acireale+CT&output=embed",
  mapsDirections: "https://www.google.com/maps/dir/?api=1&destination=Via+Vittorio+Emanuele+II+191,+Acireale+CT",
  facebook: "https://m.facebook.com/Pizzeria-Bella-Acireale-1609883302615001",
  tiktok: "https://www.tiktok.com/@pizzeriabellaacireale",
  instagram: "https://www.instagram.com/pizzeriabellaacireale",
  hours: [
    { day: "Lunedì", time: "Chiuso", closed: true },
    { day: "Martedì", time: "19:00 — 00:00" },
    { day: "Mercoledì", time: "19:00 — 00:00" },
    { day: "Giovedì", time: "19:00 — 00:00" },
    { day: "Venerdì", time: "19:00 — 00:00" },
    { day: "Sabato", time: "19:00 — 00:00" },
    { day: "Domenica", time: "19:00 — 00:00" },
  ],
};

export const SIGNATURE_PIZZAS = [
  {
    name: "Rinaldo",
    price: "15",
    ingredients: "Mozzarella Sole, scamorza affumicata, patate al forno al rosmarino, salsiccia, friarielli, olio Evo, origano di Sicilia",
    image: IMAGES.rinaldo,
  },
  {
    name: "Nordica",
    price: "16",
    ingredients: "Mozzarella Sole, salmone, scorza di limone, burrata, olio Evo, origano di Sicilia",
    image: IMAGES.nordica,
  },
  {
    name: "Trunzo",
    price: "10",
    ingredients: "Mozzarella Sole, trunzu, petali di Grana Padano DOP, aceto balsamico, olio Evo, origano di Sicilia",
    image: IMAGES.trunzo,
  },
  {
    name: "Angelica",
    price: "14",
    ingredients: "Vellutata di patate, scamorza affumicata, funghi porcini*, pancetta, olio Evo, origano di Sicilia",
    image: IMAGES.angelica,
  },
  {
    name: "Delicata",
    price: "9",
    ingredients: "Mozzarella Sole, prosciutto crudo, petali di Grana Padano DOP, olio Evo, origano di Sicilia",
    image: IMAGES.delicata,
  },
  {
    name: "Elica",
    price: "13",
    ingredients: "Mozzarella Sole, Philadelphia al pistacchio, mortadella, polvere di pistacchio, olio Evo, origano di Sicilia",
    image: IMAGES.elica,
  },
  {
    name: "Etna",
    price: "16",
    ingredients: "Mozzarella Sole, melanzane fritte, zucchine al forno, pomodoro fresco, pesto al basilico, mandorle tostate, ricotta salata, pepato fresco, burrata",
    image: IMAGES.etna,
  },
  {
    name: "Bella",
    price: "16",
    ingredients: "Mozzarella Sole, rucola, bresaola, ricotta fresca, noci, miele, olio Evo, origano di Sicilia",
    image: IMAGES.bresaola,
  },
  {
    name: "Datterina",
    price: "14",
    ingredients: "Salsa di ciliegino giallo, mozzarella di bufala campana DOP, datterino rosso, olio Evo, origano di Sicilia",
    image: IMAGES.datterina,
  },
];

export const REVIEWS = [
  {
    author: "Fabio G.",
    stars: 5,
    text: "La Pizzeria Bella ha riaperto ed è stato un vero tuffo nel passato. Lo stesso impasto buonissimo, la stessa pizza che ti fa esclamare “era proprio questa!”. Non è solo una pizzeria, è un pezzo della nostra storia acese.",
  },
  {
    author: "Gianluigi C.",
    stars: 5,
    text: "Pizze buonissime: pasta friabile, croccante al punto giusto, leggera e digeribile. Servizio impeccabile e organizzato, gentilezza e simpatia al top. Rapporto qualità prezzo ottimo.",
  },
  {
    author: "Giuseppe M.",
    stars: 5,
    text: "Tutto meraviglioso, dall'accoglienza al servizio. I pizzaioli sono bravissimi, tutto buono, buono, buono. Ritornerò sicuramente. Complimenti!",
  },
  {
    author: "Antonino P.",
    stars: 5,
    text: "Assolutamente una delle migliori pizzerie della provincia di Catania!",
  },
  {
    author: "Giulia P.",
    stars: 5,
    text: "Assolutamente da provare! Una garanzia.",
  },
];

export const MENU = [
  {
    id: "classiche",
    label: "Le Classiche",
    items: [
      { name: "Biancaneve", price: "5", ingredients: "Mozzarella Sole, olio Evo, origano di Sicilia" },
      { name: "Margherita", price: "7", ingredients: "Salsa di pomodoro, mozzarella Sole, olio Evo, origano di Sicilia" },
      { name: "Catanese", price: "8", ingredients: "Salsa di pomodoro, mozzarella Sole, cipolla, olio Evo, origano di Sicilia" },
      { name: "Norma", price: "8", ingredients: "Salsa di pomodoro, melanzane fritte, ricotta salata, olio Evo, origano di Sicilia" },
      { name: "Siciliana", price: "9", ingredients: "Pepato fresco, olive nere, acciughe, olio Evo, origano di Sicilia" },
      { name: "Tricolore", price: "9", ingredients: "Mozzarella Sole, pesto di basilico, pomodoro fresco, basilico, olio Evo, origano di Sicilia" },
      { name: "Patatosa", price: "9", ingredients: "Salsa di pomodoro, mozzarella Sole, würstel, patatine fritte, olio Evo, origano di Sicilia" },
      { name: "Delicata", price: "9", ingredients: "Mozzarella Sole, prosciutto crudo, petali di Grana Padano DOP, olio Evo, origano di Sicilia" },
      { name: "Piccantina", price: "9", ingredients: "Salsa di pomodoro, mozzarella Sole, salame piccante, olio Evo, origano di Sicilia" },
      { name: "Spezzettata", price: "10", ingredients: "Pomodoro fresco, rucola, cipolla, olive nere, sale, origano di Sicilia, olio Evo, prezzemolo, aglio, peperoncino" },
      { name: "Capricciosa", price: "10", ingredients: "Salsa di pomodoro, mozzarella Sole, piselli*, prosciutto cotto, funghi champignon*, uovo, olio Evo, origano di Sicilia" },
      { name: "Trunzu", price: "10", ingredients: "Mozzarella Sole, trunzu, petali di Grana Padano DOP, aceto balsamico, olio Evo, origano di Sicilia" },
      { name: "4 Formaggi", price: "10", ingredients: "Mozzarella Sole, gorgonzola DOP, Emmental, petali di Grana Padano DOP, olio Evo, origano di Sicilia" },
      { name: "Tonnara", price: "10", ingredients: "Salsa di pomodoro, mozzarella Sole, tonno, olive nere, cipolla, olio Evo, origano di Sicilia" },
      { name: "Vegetariana", price: "10", ingredients: "Zucchine al forno, melanzane al forno, spinaci*, pepato fresco, pomodoro fresco, olio Evo, origano di Sicilia" },
      { name: "Fattoressa", price: "10", ingredients: "Salsa di pomodoro, mozzarella Sole, piselli*, prosciutto cotto, olive nere, acciughe, olio Evo, origano di Sicilia" },
      { name: "Ida", price: "10", ingredients: "Salsa di pomodoro, mozzarella di bufala campana DOP, prosciutto cotto, olive nere, olio Evo, origano di Sicilia" },
      { name: "Pistacchio", price: "10", ingredients: "Mozzarella Sole, panna al pistacchio, speck, polvere di pistacchio, olio Evo, origano di Sicilia" },
      { name: "Parmigiana", price: "11", ingredients: "Salsa di pomodoro, mozzarella Sole, prosciutto cotto, melanzane fritte, uovo, petali di Grana Padano DOP, olio Evo, origano di Sicilia" },
      { name: "Rucola", price: "11", ingredients: "Mozzarella Sole, pomodoro fresco, prosciutto crudo, rucola, petali di Grana Padano DOP, olio Evo, origano di Sicilia" },
      { name: "Spezzettata col Trunzo", price: "11", ingredients: "Pomodoro fresco, trunzo, cipolla, olive nere, sale, origano di Sicilia, olio Evo, prezzemolo, aglio, peperoncino" },
      { name: "Montanara", price: "12", ingredients: "Mozzarella Sole, salsa di pomodoro, funghi porcini*, prosciutto crudo, petali di Grana Padano DOP, olio Evo, origano di Sicilia" },
      { name: "Magma", price: "13", ingredients: "Salsa di pomodoro, mozzarella Sole, salame piccante, cipolla, olive nere, patate al forno al rosmarino, olio Evo, origano di Sicilia" },
    ],
  },
  {
    id: "speciali",
    label: "Le Speciali",
    items: [
      { name: "Elica", price: "13", ingredients: "Mozzarella Sole, Philadelphia al pistacchio, mortadella, polvere di pistacchio, olio Evo, origano di Sicilia", image: IMAGES.elica },
      { name: "Trinacria", price: "14", ingredients: "Pepato fresco, mozzarella Sole, pomodoro fresco, cipolla, olive nere, salsiccia, olio Evo, origano di Sicilia" },
      { name: "Orlando", price: "14", ingredients: "Mozzarella Sole, pomodoro fresco, patate al forno al rosmarino, cipolla, pepato fresco, speck infornato, olio Evo, origano di Sicilia" },
      { name: "Angelica", price: "14", ingredients: "Vellutata di patate, scamorza affumicata, funghi porcini*, pancetta, olio Evo, origano di Sicilia", image: IMAGES.angelica },
      { name: "Regina", price: "14", ingredients: "Mozzarella Sole, gorgonzola DOP, speck, noci, miele, olio Evo, origano di Sicilia" },
      { name: "Sfiziosa", price: "14", ingredients: "Mozzarella Sole, gorgonzola DOP, Philadelphia al pistacchio, noci, rucola, olio Evo, origano di Sicilia" },
      { name: "Datterina", price: "14", ingredients: "Salsa di pomodoro ciliegino giallo, Datterino rosso, mozzarella di bufala Campana DOP, olio Evo, origano di Sicilia", image: IMAGES.datterina },
      { name: "Rinaldo", price: "15", ingredients: "Mozzarella Sole, scamorza affumicata, patate al forno al rosmarino, salsiccia, friarielli, olio Evo, origano di Sicilia" },
      { name: "Etna", price: "16", ingredients: "Mozzarella Sole, melanzane fritte, zucchine al forno, pomodoro fresco, pesto al basilico, mandorle tostate, ricotta salata, pepato fresco, burrata, olio Evo, origano di Sicilia", image: IMAGES.etna },
      { name: "Nordica", price: "16", ingredients: "Mozzarella Sole, salmone, scorza di limone, burrata, olio Evo, origano di Sicilia", image: IMAGES.nordica },
      { name: "Bella", price: "16", ingredients: "Mozzarella Sole, rucola, bresaola, ricotta fresca, noci, miele, olio Evo, origano di Sicilia", image: IMAGES.bresaola },
    ],
  },
  {
    id: "calzoni",
    label: "Calzoni",
    items: [
      { name: "Calzone", price: "9", ingredients: "Salsa di pomodoro, mozzarella Sole, prosciutto cotto, olio Evo, origano di Sicilia" },
      { name: "Calzone Verde", price: "9", ingredients: "Mozzarella Sole, spinaci*, olive nere, olio Evo, origano di Sicilia" },
      { name: "Calzone al Pistacchio", price: "12", ingredients: "Mozzarella Sole, Philadelphia al pistacchio, mortadella, polvere di pistacchio, olio Evo, origano di Sicilia" },
    ],
  },
  {
    id: "dolci",
    label: "Pizze Dolci",
    items: [
      { name: "Focaccia Nera", price: "8", ingredients: "Nutella, zucchero a velo" },
      { name: "Spezzettata Dolce", price: "10", ingredients: "Nutella, zucchero a velo, granella di nocciole" },
      { name: "Spezzettata al Pistacchio", price: "12", ingredients: "Crema di pistacchio, polvere di pistacchio, zucchero a velo" },
    ],
  },
  {
    id: "contorni",
    label: "Contorni & Per Finire",
    items: [
      { name: "Patatine fritte", price: "4" },
      { name: "Patatine fritte dippers con buccia", price: "6" },
    ],
    extras: [
      {
        title: "Per Finire",
        items: [
          { name: "Caffè", price: "1" },
          { name: "Amaro", price: "4" },
          { name: "Grappa", price: "4" },
          { name: "Dessert", price: "7", ingredients: "Chiedi allo staff" },
        ],
      },
    ],
  },
  {
    id: "bevande",
    label: "Bevande & Birre",
    items: [
      { name: "Acqua Naturale 0,75 cl", price: "2" },
      { name: "Acqua Gasata 0,75 cl", price: "2" },
      { name: "Coca-Cola 0,33 cl", price: "3" },
      { name: "Coca-Cola Zero 0,33 cl", price: "3" },
      { name: "Fanta 0,33 cl", price: "3" },
      { name: "Sprite 0,33 cl", price: "3" },
      { name: "Chinotto 0,33 cl", price: "3" },
    ],
    extras: [
      {
        title: "Birre Angelo Poretti",
        items: [
          { name: "4 Luppoli Bionda 0,20 cl", price: "4" },
          { name: "4 Luppoli Bionda 0,40 cl", price: "6" },
          { name: "6 Luppoli Rossa 0,20 cl", price: "4" },
          { name: "6 Luppoli Rossa 0,40 cl", price: "6" },
        ],
      },
      {
        title: "Birra Artigianale OBS",
        items: [
          { name: "Bianca 0,33 cl", price: "6", ingredients: "Malto d'orzo e grano" },
          { name: "Rossa 0,33 cl", price: "6", ingredients: "7 malti d'orzo" },
        ],
      },
    ],
  },
  {
    id: "vini",
    label: "Vini",
    firstTitle: "Vino Rosso",
    firstTitle_en: "Red Wine",
    note: "* bottiglia · ** solo calice",
    items: [
      { name: "Paolini Etta Focu", price: "15*", ingredients: "Vitigni: Syrah, Perricone (in appassimento) · Zona: Marsala (TP)" },
      { name: "Gorghi Tondi Meridiano 12 Syrah", price: "17*", ingredients: "Vitigni: Syrah · Zona: Mazara del Vallo (TP)" },
      { name: "Gorghi Tondi Coste a Preola Nero d'Avola", price: "17*", ingredients: "Vitigni: Nero d'Avola · Zona: Mazara del Vallo (TP)" },
      { name: "Puglisi Altus Etna Rosso", price: "20*", ingredients: "Vitigni: Nerello Mascalese · Zona: Passo Pisciaro, Castiglione di Sicilia (CT)" },
    ],
    extras: [
      {
        title: "Vino Bianco",
        items: [
          { name: "Paolini Disiu", price: "16*", ingredients: "Vitigni: Grillo · Zona: Marsala (TP)" },
        ],
      },
      {
        title: "Vino Rosato",
        items: [
          { name: "Pittimusa", price: "20*", ingredients: "Vitigni: Nerello Mascalese Terre Siciliane · Zona: San Giovanni Montebello (CT)" },
        ],
      },
      {
        title: "Bollicine",
        items: [
          { name: "Saint German Spumante Brut Firriato", price: "18*", ingredients: "Vitigni: Grillo e Catarratto · Zona: Trapani (TP)" },
        ],
      },
      {
        title: "Vino della Casa",
        items: [
          { name: "Vino della Casa", price: "5**" },
        ],
      },
    ],
  },
];

export const MENU_EXTRAS = [
  { name: "Coperto", price: "2" },
  { name: "Aggiunte", price: "da 2 a 4" },
  { name: "Impasto Farina di Timilia", price: "2" },
  { name: "Impasto Farina Integrale", price: "2" },
];
